// Redux Action Types
import { SET_UNITS } from '../actions/types';
// Initial State
const initialState = [];

export default function (state = initialState, action) {
  if (action.type === SET_UNITS) return action.payload;
  return state;
}
